export default "__VITE_ASSET__C77DDhdk__"